import type { LanguageCode } from "../languages/language-codes";
import type { MetadataLanguageAccordionItemFragment } from "../client/generated";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@acdc2/ui/components/button";
import { LanguageCommand } from "../languages/LanguageCommand";
import { Badge } from "@acdc2/ui/components/badge";
import { Icon } from "@mdi/react";
import { mdiUnfoldMoreHorizontal } from "@mdi/js";
import { useSetDocumentLanguageMutation } from "../client/generated";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@acdc2/ui/components/accordion";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@acdc2/ui/components/popover";

type Props = {
  fragment: MetadataLanguageAccordionItemFragment;
};

export function MetadataLanguageAccordionItem({ fragment }: Props) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const currentCode = fragment.metadata.language as LanguageCode;

  const [setDocumentLanguage] = useSetDocumentLanguageMutation();

  const onSelect = async (code: LanguageCode) => {
    await setDocumentLanguage({
      variables: {
        documentId: fragment.id,
        language: code,
      },
    });
    setOpen(false);
  };

  return (
    <AccordionItem value="language">
      <AccordionTrigger className="px-4">
        {t("MetadataLanguageAccordionItem.label")}
      </AccordionTrigger>
      <AccordionContent className="flex flex-col px-4 pt-1">
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <Button variant="outline" role="combobox" aria-expanded={open}>
              {t(`LanguageCommand.labels.${currentCode}`)}
              <Badge className="ml-auto">{currentCode.toUpperCase()}</Badge>
              <Icon path={mdiUnfoldMoreHorizontal} />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="p-0 mx-2">
            <LanguageCommand value={currentCode} onSelect={onSelect} />
          </PopoverContent>
        </Popover>
      </AccordionContent>
    </AccordionItem>
  );
}
